import { Component } from "@angular/core";

@Component({ template: `<p>Je bent uitgelogd.</p>` })
export class LogoutCallbackComponent { }
